// eslint-disable-next-line no-unused-vars
import request from '@/service/http'

export function studentSearch (data) {
  return request({
    url: '/api/organization-search',
    method: 'post',
    data,
  })
}

export function studentUpdata (data) {
  return request({
    url: '/api/student/update',
    method: 'post',
    data,
  })
}
export function studentSave (data) {
    return request({
      url: '/api/student/save',
      method: 'post',
      data,
    })
  }
  export function searchList (data) {
    return request({
      url: '/api/student/searchList',
      method: 'post',
      data,
    })
  }
  export function studentDetail (data) {
    return request({
      url: '/api/student/detail',
      method: 'post',
      data,
    })
  }
export function stdentDeleteed (data) {
  return request({
    url: '/api/student/delete',
    method: 'post',
    data,
  })
}
export function addCustomerFileUpload (data) {
  return request({
    url: '/api/student/addCustomerFile',
    method: 'post',
    data,
  })
}
export function signinList (data) {
  return request({
    url: '/api/student/signinList',
    method: 'post',
    data,
  })
}
export function curriculumList (data) {
  return request({
    url: '/api/student/curriculumList',
    method: 'post',
    data,
  })
}
export function detail (data) {
  return request({
    url: '/api/student/detail',
    method: 'post',
    data,
  })
}
export function editDetail (data) {
  return request({
    url: '/api/student/editDetail',
    method: 'post',
    data,
  })
}

export function signInSearch (data) {
  return request({
    url: '/api/student/signInSearch',
    method: 'post',
    data,
  })
}

export function getImportExcel(data,callback) {
  return request({
      url: '/student/getImportExcel',
      method: 'post',
      onUploadProgress: callback,
      data,
  })
}

export function getStudentInfo (idCardNum,telNo) {
  return request({
    url: '/api/student/getStudentInfo',
    method: 'get',
    params: {
      idCardNum: idCardNum,
      telNo: telNo
    },
  })
}

